/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: useWindowResize.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  08.06.23 11:47 am.
 * Last modified: 08.06.23 11:47 am.
 *
 * More information at: https://egt-digital.com/
 */

import { useEffect, useState } from 'react';
import { debounceTime, fromEvent, merge } from 'rxjs';

const WINDOW_RESIZED_WIDTH = merge(fromEvent(window, 'resize'), fromEvent(window, 'orientationchange'));

export const useWindowResize = (effect: React.EffectCallback, deps: any[]): void => {
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

    useEffect(() => {
        const subscription = WINDOW_RESIZED_WIDTH.pipe(debounceTime(50)).subscribe(() => {
            setWindowWidth(window.innerWidth);
        });

        return () => subscription.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, [windowWidth, ...deps]);
};
